import type { ContextModalProps } from '@mantine/modals';

import AOSModal from '@/new_src/view/components/WebView/Native/AOS/AOSModal';
import IOSModal from '@/new_src/view/components/WebView/Native/IOS/IOSModal';

import { OS_TYPE } from 'consts/device';
import { useDevice } from 'hooks/useDevice';

export interface AppModalProps {
  modalBody: string;
  confirmButton: {
    onClick?: () => void;
    label?: string;
  };
  cancelButton?: {
    onClick: () => void;
    label?: string;
  };
}

const AppModal = ({ context, id, innerProps }: ContextModalProps<AppModalProps>) => {
  const { os } = useDevice();

  if (os === OS_TYPE.OS_IOS || os === OS_TYPE.OS_MACOS) {
    return <IOSModal innerProps={innerProps} id={id} context={context} />;
  } else {
    return <AOSModal innerProps={innerProps} id={id} context={context} />;
  }
};

export { AppModal };
